// extracted by mini-css-extract-plugin
export default {"content":"style_content__kitoN","checkbox":"style_checkbox__ov-IR"};